import { render } from "./ModalBillOfMaterialDetail.vue?vue&type=template&id=827ac33c"
import script from "./ModalBillOfMaterialDetail.vue?vue&type=script&lang=js"
export * from "./ModalBillOfMaterialDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__